import { AccessControlFeatureKey } from '@shared/constants/features.const';

export const PARAMETERS_LIMITS_COMMON = [
  AccessControlFeatureKey.FtsRoute,
  AccessControlFeatureKey.FtsOverspeed,
  AccessControlFeatureKey.FtsSpeedRpm,
  AccessControlFeatureKey.FtsKm,
  AccessControlFeatureKey.FtsReportsInfractions,
  AccessControlFeatureKey.FtsIssues,
  AccessControlFeatureKey.FtsPerimeters,
  AccessControlFeatureKey.WorkedHours,
  AccessControlFeatureKey.Onboard,
] as const;

export const PARAMETERS_LIMITS_INFRACTIONS = [
  AccessControlFeatureKey.ReportsInfractions,
  AccessControlFeatureKey.FtsReportsInfractions,
  AccessControlFeatureKey.Onboard,
] as const;
